<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3 mb-0">
            <h4 class="breadcrumb_title_page">รายละเอียดสมาชิก</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
          </div>
        </v-col>
      </v-row>

      <section class="mt-10">
        <div class="ma-5">
          <v-card elevation="4" class="pa-3 card_relative">
            <div class="tag_header_profile d-flex">
              <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/avatar_white.png">
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color-two py-1 pl-8 pr-5">ข้อมูลสมาชิก</div>
              </v-card>
            </div>
            <v-row class="pa-4">
              <v-col cols="12" lg="6" md="6" sm="6">
                <div class=" text_title">ชื่อลูกค้า : <span class="text_detail">{{ memberList.member_name }}</span>
                </div>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6">
                <div class=" text_title">เลขที่เสียภาษี : <span class="text_detail">{{ memberList.tax_number
                  ? memberList.tax_number : '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6">
                <div class=" text_title">เลขที่สาขา : <span class="text_detail">{{ memberList.branch_number
                  ? memberList.branch_number : '-' }}</span>
                </div>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6">
                <div class=" text_title">เบอร์โทร : <span class="text_detail">{{ memberList.tel_number }}</span></div>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6">
                <div class=" text_title">ที่อยู่ : <span class="text_detail">{{ memberList.address }} {{ memberList.sub_district }} {{ memberList.district }}{{ memberList.province }}{{ memberList.postcode }}</span></div>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6">
                <div class=" text_title">โน๊ต : <span class="text_detail">{{ memberList.note
                  ? memberList.note : '-' }}</span></div>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </section>
      <section class="mt-15">
        <div class="ma-5">
          <v-card elevation="4" class="pa-3 card_relative">
            <div class="tag_header_profile d-flex">
              <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/point.png">
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color py-1 pl-8 pr-5">ประวัติการใช้แต้ม</div>
              </v-card>
            </div>
            <div class="mt-4">
              <v-data-table :headers="headers" :items="pointLog" :search="search" :footer-props="footer_Props"
              mobile-breakpoint="0">
              <template v-slot:item="pointList">
                <tr>
                  <td>{{pointList.item.create_at  != null ? `${pointList.item.create_at.split('-')[2].split(' ')[0]}-${pointList.item.create_at.split('-')[1]}-${pointList.item.create_at.split('-')[0]}` : '-'}}</td>
                  <td>{{pointList.item.log_name}}</td>
                  <td class="text-center">+{{pointList.item.point_recieve == null ? 0 : pointList.item.point_recieve}}</td>
                  <td class="error--text text-center">-{{pointList.item.point_use == null ? 0 : pointList.item.point_use}}</td>
                  <td class="text-center">{{pointList.item.point_remain}}</td>
                </tr>
              </template>
            </v-data-table>
           
            </div>
          </v-card>
        </div>
      </section>

      <!-- ประวัติการสั่งซื้อ -->
      <section class="mt-15">
        <div class="ma-5">
          <v-card elevation="4" class="pa-3 card_relative">
            <div class="tag_header_profile d-flex">
              <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/point.png">
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color py-1 pl-8 pr-5">ประวัติการซื้อสินค้า</div>
              </v-card>
            </div>
            <div class="d-flex justify-end">
              <div class="mt-1">
                <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required
                  v-model="searchData" placeholder="ค้นหา..." outlined dense></v-text-field>
              </div>
            </div>
            <div class="mt-4">
              <v-data-table :headers="headers_history" :items="orderList" :search="searchData" :footer-props="footer_Props"
              mobile-breakpoint="0">
              <template v-slot:item="orderData">
                <tr>
                  <td>{{orderData.item.product_code}}</td>
                  <td>{{orderData.item.product_name}}</td>
                  <td>{{orderData.item.product_name_sci}}</td>
                  <td>{{orderData.item.product_type_name}}</td>
                  <td class="text-center">{{orderData.item.qty}}</td>
                  <td class="text-center">{{orderData.item.unit_name}}</td>
                </tr>
              </template>
            </v-data-table>
            </div>
          </v-card>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Detail_customer_point",
  data() {
    return {
      loading_page: false,
      memberList: [],
      orderList:[],
      pointLog: [],
      searchData:'',
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'การสะสมแต้มลูกค้า',
          disabled: false,
        },
        {
          text: 'รายการสมาชิก',
          disabled: false,
        },
        {
          text: 'รายละเอียดสมาชิก',
          disabled: false,
          href: '#',
        },
      ],
      headers:[
        {
          text: 'วันที่',
          value: 'create_at',
          fixed: true,
          sortable: false,
          align: 'left',
        },
        {
          text: 'รายการ',
          value: 'log_name',
          fixed: true,
          align: 'left',
        },
        {
          text: 'แต้มที่ได้รับ',
          value: 'point_recieve',
          fixed: true,
          align: 'center',
        },
        {
          text: 'แต้มที่ใช้ไป',
          value: 'point_use',
          fixed: true,
          align: 'center',
        },
        {
          text: 'แต้มที่เหลือ',
          value: 'point_remain',
          fixed: true,
          align: 'center',
        },
      ],
      headers_history:[
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          sortable: false,
          align: 'left',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          align: 'left',
        },
        {
          text: 'ชื่อทางการแพทย์',
          value: 'product_name_sci',
          fixed: true,
          align: 'left',
        },
        {
          text: 'ประเภทสินค้า',
          value: 'product_type_name',
          fixed: true,
          align: 'left',
        },
        {
          text: 'จำนวนที่ซื้อ',
          value: 'qty',
          fixed: true,
          align: 'center',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          align: 'center',
        },
      ],
    }
  },
  methods: {
    getMember() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/member/get/detail/' + this.$route.params.id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.memberList = res.data.memberData;
          this.pointLog = res.data.pointLog;
        }
      })
    },

    async getOrder() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      await HTTP_ARIN.get('/member/get/buy-history/' + this.$route.params.id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.orderList = res.data.buyHistory;
        }
      })
    },
  },
  mounted() {
    this.getMember()
    this.getOrder()
  },
  computed: {
  filteredOrderList() {
    return this.orderList.filter(item => {
      return item.product_code.includes(this.searchData) ||
             item.product_name.includes(this.searchData) ||
             item.product_name_sci.includes(this.searchData) ||
             item.product_type_name.includes(this.searchData);
    });
  }
}
}
</script>

<style scoped>
.card_relative {
  position: relative;
  border-radius: 15px;
}

.profile_detail {
  display: grid;
  grid-template-columns: 30% 70%;
}

.header_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.logo_timeline {
  width: 25px;
  height: 25px;
  padding: 0px;
}

.logo_timeline>img {
  max-width: 25px;
}

.tag_header_profile {
  position: absolute;
  top: -30px;
  left: -15px;
}

.arin-text-color {
  color: #84611F;
  font-weight: bold;
  font-size: 16px;
}

.arin-text-color-two {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.card_title {
  margin-top: 1px;
  margin-bottom: 1px;
  border-radius: 10px;
  border: 1px solid #D6BFAF;
}

.preview {
  border-radius: 10px;
}

.employee_box {
  border-radius: 10px;
  border: 1px solid #D6BFAF;
  width: auto;
}

.sub_title {
  font-size: 16px;
}

.image_title {
  font-weight: 500;
  font-size: 16px;
}

.picture_details {
  display: grid;
  grid-template-columns: 40% 60%;
}

.mobile_btn {
  width: 40%;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_four_ck {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}

.text_title {
  color: #909090;
  font-weight: bold;
  font-size: 16px;
}

.text_detail {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}
</style>
